import { createContext, useContext } from "react";

const JobContext = createContext();

export const useJobs = () => useContext(JobContext);


export default JobContext;
